export default __webpack_public_path__ + "static/media/Reuben.702ef2b8.png";